import axios from 'axios';
import {
  Workspace,
  WorkspaceListResponse,
  WorkspaceCreateParams,
  WorkspaceUpdateParams,
  WorkspaceSearchParams,
  WorkspaceMember,
  WorkspaceMemberListResponse,
  WorkspaceMemberSearchParams,
} from '@/types/workspace';

/**
 * 查询当前登录用户加入的工作空间列表
 */
export const listUserWorkspacesApi = () => {
  return axios.get<{ results: Workspace[] }>(
    '/api/console/user/v1/workspaces/list'
  );
};

/**
 * 创建工作空间
 */
export const createWorkspaceApi = (data: WorkspaceCreateParams) => {
  return axios.post<{ workspace_uuid: string }>(
    '/api/console/workspace/v1/create',
    data
  );
};

/**
 * 查询工作空间详情
 */
export const getWorkspaceApi = (data: {
  tenant_uuid: string;
  workspace_uuid: string;
}) => {
  return axios.post<{ workspace: Workspace }>(
    '/api/console/workspace/v1/get',
    data
  );
};

/**
 * 查询指定租户下的工作空间列表
 */
export const listWorkspacesApi = (data: WorkspaceSearchParams) => {
  return axios.post<WorkspaceListResponse>(
    '/api/console/workspace/v1/list',
    data
  );
};

/**
 * 更新工作空间
 */
export const updateWorkspaceApi = (data: WorkspaceUpdateParams) => {
  return axios.post<void>('/api/console/workspace/v1/update', data);
};

/**
 * 邀请工作空间成员
 */
export const inviteWorkspaceMemberApi = (data: {
  inviter_tenant_uuid: string;
  inviter_workspace_uuid: string;
  invitee_email: string;
}) => {
  return axios.post<void>('/api/console/workspace/member/v1/invite', data);
};

/**
 * 响应工作空间邀请
 */
export const respondWorkspaceInvitationApi = (data: {
  notification_id: number;
  accept_status: 2 | 3; // 2: 接受, 3: 拒绝
}) => {
  return axios.post<void>(
    '/api/console/workspace/member/v1/invitation/respond',
    data
  );
};

/**
 * 查询工作空间成员详情
 */
export const getWorkspaceMemberApi = (data: {
  tenant_uuid: string;
  workspace_uuid: string;
  user_uuid: string;
}) => {
  return axios.post<{ workspace_member: WorkspaceMember }>(
    '/api/console/workspace/member/v1/get',
    data
  );
};

/**
 * 查询工作空间成员列表
 */
export const listWorkspaceMembersApi = (data: WorkspaceMemberSearchParams) => {
  return axios.post<WorkspaceMemberListResponse>(
    '/api/console/workspace/member/v1/list',
    data
  );
};

/**
 * 更新工作空间成员
 */
export const updateWorkspaceMemberApi = (data: {
  workspace_uuid: string;
  user_uuid: string;
  type?: number;
}) => {
  return axios.post<void>('/api/console/workspace/member/v1/update', data);
};

/**
 * 移除工作空间成员
 */
export const removeWorkspaceMemberApi = (data: {
  workspace_uuid: string;
  user_uuid: string;
}) => {
  return axios.post<void>('/api/console/workspace/member/v1/remove', data);
};

/**
 * 离开工作空间
 */
export const leaveWorkspaceApi = (data: {
  tenant_uuid: string;
  workspace_uuid: string;
}) => {
  return axios.post<void>('/api/console/workspace/member/v1/leave', data);
};

export default {
  listUserWorkspacesApi,
  createWorkspaceApi,
  getWorkspaceApi,
  listWorkspacesApi,
  updateWorkspaceApi,
  getWorkspaceMemberApi,
  listWorkspaceMembersApi,
  updateWorkspaceMemberApi,
  removeWorkspaceMemberApi,
  leaveWorkspaceApi,
};
